import styled from 'styled-components';
import { Link as _Link } from 'react-router-dom';
import { ReactComponent as CloseIcon } from 'products/nomad_insurance/assets/img/icons/close.svg';
import { th } from 'style/theme';
import { sizes } from 'style';

export const StyledPill = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  // negative bottom margin to offset the margin on the tabs
  margin: 60px 10px -40px 10px;
  padding: 8px 16px;
  border-radius: 24px;
  background-color: ${th('colors.yellow')};
  box-shadow: ${th('shadows.small')};

  @media ${sizes.desktop} {
    display: none;
  }

  @media ${sizes.extraLargeDesktop} {
    display: flex;
    position: absolute;
    top: 76px;
    right: 32px;
    margin: 0;
  }
`;

export const Link = styled(_Link)`
  font-weight: 500;
  color: inherit;
`;

export const Close = styled(CloseIcon)`
  width: 13px;
  margin-left: 12px;
  cursor: pointer;
`;
